import React, { Component, Fragment } from 'react'
import { convertToRupiah, copyText } from '../../../../config/utils';
import { CORE_API_AKADEMIK } from '../../../../services/key/api';

export default class VirtualAccount extends Component {
    constructor(props) {
        super(props)
        this.state =  {
            isCopyText: false,
            time: 300,
            paymentSuccess: false
        }
    }

    componentWillUnmount() {
        if (this.props.config.isDisplayTagihan) {
            clearInterval(this.interval);
            this.evtSource?.close()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.isCopyText) {
            setTimeout(() => {
                this.setState({
                  isCopyText: false
                })
            }, 2000);
        }

        if (this.props.config.isDisplayTagihan && this.props.config.status && !prevProps.config.status) {
          this.countDown();
          this.initializeClientSSE()
        }
    }

    setCopyText = () => {
      copyText(this.props.config.nomor_va)

      this.setState({
        isCopyText: true
      })
    }

    countDown() {
        this.interval = setInterval(() => {
          const { time } = this.state;
          if (time > 0) {
            this.setState({ time: time - 1 });
          } else {
            clearInterval(this.interval);
            this.evtSource.close();
          }
        }, 1000);
    }

    
    initializeClientSSE = () => {
        const { id_trx } = this.props.config

        this.evtSource = new EventSource(
            `${process.env.REACT_APP_CORE_API_AKADEMIK}module/callback/client/${id_trx}`
        );
    
        this.evtSource.onmessage = (event) => this.getSSEData(event.data);
    
        this.evtSource.onerror = () => {
            this.evtSource.close();
        }
    };

    closeNotificationSSE = async () => {
        const { id_trx } = this.props.config

        await CORE_API_AKADEMIK.get('module/read/' + id_trx)
    }

    getSSEData = (data) => {
        let parse = JSON.parse(data);

        if (parse.data.length !== 0) {
            if (parse.data[0].status_bayar === 'L') {
                this.setState({
                    VA: parse.data[0],
                    paymentSuccess: true
                });
        
                sessionStorage.setItem('riwayatTF', data)
        
                setTimeout(() => {
                    // TODO: close subscription
                    this.closeNotificationSSE();
                }, 5000);

                this.evtSource.close();
                clearInterval(this.interval)
            }

        }
    };

    closePayment = () => {
        if (this.props.config.isDisplayTagihan) {
            clearInterval(this.interval)
            this.evtSource.close()
            this.setState({ time: 300, paymentSuccess: false })
        }

        this.props.toggleShow();
    }
  
    render() {
        const { bank, nomor_va, status, id_trx, real_amount, isDisplayTagihan } = this.props.config
        const { VA } = this.state

        const { time } = this.state;
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

        return (
            <Fragment>
                <div className="modal fade" id="nilai" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div style={ !status ? {} : { background: 'transparent', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1051 }} />
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" style={{ zIndex: 1052 }}>
                            <div className="modal-header d-flex justify-content-center">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Detail Virtual Account
                                </h5>
                            </div>
                            {
                                id_trx && isDisplayTagihan
                                    ? this.state.paymentSuccess 
                                        ? <div className='bg-success'>
                                            <div className='d-flex align-items-center bg-success'>
                                                <i className='ti-check menu-icon p-4' />
                                                <div className='d-flex flex-column'>
                                                    <h5>Transaksi sebesar {convertToRupiah(VA?.trx_amount || 0)} berhasil dilakukan!</h5>
                                                    <p style={{ lineHeight: 1 }}>Silahkan lakukan konfirmasi ke BAA</p>
                                                </div>
                                            </div>
                                            <table className="display expandable-table tableBord table-striped" style={{ width: "100%"}}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Invoice</td>
                                                        <td> : </td>
                                                        <td>{VA?.id_invoice}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Waktu Bayar</td>
                                                        <td> : </td>
                                                        <td>{VA?.datetime_payment}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        : <div className='bg-primary d-flex justify-content-center align-items-center text-light'>
                                            <i className='ti-time' />&nbsp;&nbsp;Menunggu Pembayaran {minutes}:{formattedSeconds}
                                        </div>
                                    : <div className='bg-danger d-flex justify-content-center align-items-center text-light'>
                                        <i className='ti-close' />&nbsp;&nbsp;Sedang tidak ada tagihan
                                    </div>
                            }
                            <div className="content-wrapper pl-3 pr-3 pt-3 pb-5 d-flex flex-column align-items-center">
                                <div className="mb-4 stretch-card transparent virtual-card">
                                    <div className='card card-light-danger'>
                                        <div className="card-body">
                                            <p className="mb-4 putih h4">{bank}</p>
                                            <div className="d-flex justify-content-between fs-30 mb-2 putih">
                                                <p className='fs-30' style={{ textOverflow: 'ellipsis', maxWidth: 400, whiteSpace: 'nowrap', overflow: 'hidden' }}>{nomor_va?.toString().replace(/\d{4}(?=.)/g, '$& ')}</p>
                                                <span onClick={this.setCopyText} className='float-right d-flex flex-column align-items-center' style={{ cursor: 'pointer', width: 50 }}>
                                                    <i className='far fa-copy' />
                                                    <p style={{ position: 'absolute', bottom: '25%' }} hidden={this.state.isCopyText ? false : true}>Tersalin!</p>
                                                </span>
                                            </div>
                                            <br />
                                            <p className="putih">Virtual Account {bank}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex flex-column w-100 mt-3 TapS rounded-0 shadow-none p-3' style={{ whiteSpace: 'normal' }}>
                                    <span className='mb-3'>Total Tagihan</span>
                                    <h3 className='font-weight-bold'>{convertToRupiah(isDisplayTagihan && id_trx ? real_amount : 0)}</h3>
                                </div>
                                <div className='TapS rounded-0 shadow-none p-4' style={{ whiteSpace: 'normal' }}>
                                    <div className='d-flex flex-column'>
                                        <h4 className='font-weight-bold'>Cara Transfer</h4>
                                        <ul>
                                            <li><span>Pilih menu "Transfer antar bank" atau "Transfer online antarbank".</span></li>
                                            <li><span>Masukkan kode bank {bank} {bank === 'BNI' ? '009' : '008'} atau pilih bank yang dituju yaitu {bank === 'BNI' ? 'BNI' : 'Mandiri'}.</span></li>
                                            <li><span>Masukan 16 Digit Nomor Virtual Account pada kolom rekening tujuan.</span></li>
                                            <li><span>Masukkan nominal transfer sesuai tagihan atau kewajiban Anda. Nominal yang berbeda tidak dapat diproses.</span></li>
                                            <li><span>Masukkan jumlah pembayaran</span></li>
                                            <li><span>Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silahkan lanjutkan transaksi sampai dengan selesai.</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='modal-footer d-flex justify-content-center'>
                                <button 
                                    type="button" 
                                    onClick={this.closePayment} 
                                    className={`btn ${this.state.paymentSuccess ? 'text-success' : 'text-danger'}`} 
                                    data-dismiss="modal"
                                >
                                    {this.state.paymentSuccess ? 'Selesai' : 'Batalkan Transaksi'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
